import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class DateFormatService {

  constructor() { }

  formatDate(date :Date) : string {
    let dateString : string = moment(date).format("DD/MM/YYYY").toString();
    // let dateString : string = date.getDate() + "/" + (date.getMonth()+1) + "/" + date.getFullYear();
    return dateString;
  }

  formatDateTime(date :Date) : string {
    let dateString : string = moment(date).format("DD/MM/YYYY  HH:mm a").toString();
    // let dateString : string = date.getDate() + "/" + (date.getMonth()+1) + "/" + date.getFullYear();
    return dateString;
  }

  parseDate(dateString: string) {
    let date: Date = moment(dateString,'DD/MM/YYYY').toDate();
    return date;
  }

  formatDateForm_YYYY_MM_DD(date : string) : string {
    let dateString : string = moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    return dateString;
  }

  formatDateTimeYYYY_MM_DD_HH_mm_ss(date :Date) : string {
    let dateString : string = moment(date).format("YYYY-MM-DD HH:mm:ss").toString();
    // let dateString : string = date.getDate() + "/" + (date.getMonth()+1) + "/" + date.getFullYear();
    return dateString;
  }

  formatDate_dd_MM_yyyy(date :Date) : string {
    let dateString : string = moment(date).format("YYYY-MM-DD").toString();
    // let dateString : string = date.getDate() + "/" + (date.getMonth()+1) + "/" + date.getFullYear();
    return dateString;
  }

  
}
